import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import { cancelCellEdit } from '../../actions/grid-screen';
import { updateRetargetingCommonPriceCell } from '../../actions/retargetingCommonPriceEditor';
import {
    PhraseMoneyCellEditor,
    PhraseMoneyCellEditorProps,
    PhraseMoneyCellEditorTypes
} from '../../components/PhraseMoneyCellEditor/PhraseMoneyCellEditor';
import { selectGridSourceParams } from '../../selectors/gridSourceParams/gridSourceParams';
import { getEditCellData } from '../../service/GridHelpers/GridHelpers';
import { ConstData } from '../../typings/constants';
import { State } from '../../typings/state';

export type StateProps = Pick<
    PhraseMoneyCellEditorProps,
    'isSaving' | 'error' | 'priceLimit' | 'isGridScrolling'
>;

export interface DispatchProps {
    onSave: (value: number) => void;
    onCancel: () => void;
}

export type OwnProps = {
    id: string;
    cellName: string;
    currency: string;
    bid?: number;
    constants: ConstData;
};

const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => {
    const { editCellsData, isGridScrolling } = state.grid;
    const { id, cellName, constants, currency } = ownProps;
    const { view } = selectGridSourceParams(state);

    return {
        priceLimit: constants.currencyConstants[currency],
        isGridScrolling,
        ...getEditCellData(editCellsData, id, cellName, view)
    };
};

const mapDispatchToProps = (
    dispatch: Dispatch<Action>,
    ownProps: OwnProps
): DispatchProps => {
    const { cellName, id } = ownProps;

    return {
        onSave: (value: number) => {
            dispatch(
                updateRetargetingCommonPriceCell(
                    {
                        id,
                        priceContext: value
                    },
                    cellName
                )
            );
        },
        onCancel: () => {
            dispatch(cancelCellEdit(id, cellName));
        }
    };
};

const mergeProps = (
    stateProps: StateProps,
    dispatchProps: DispatchProps,
    ownProps: OwnProps
): PhraseMoneyCellEditorProps => {
    const { currency, bid } = ownProps;

    return {
        ...{ currency, bid },
        ...stateProps,
        ...dispatchProps,
        type: PhraseMoneyCellEditorTypes.simple
    };
};

export const RetargetingMoneyCellEditorContainer = connect<
    StateProps,
    DispatchProps,
    OwnProps,
    PhraseMoneyCellEditorProps
>(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(PhraseMoneyCellEditor);
